import { Menu } from "antd"
import React from "react"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCalendar, faSliders, faUser, faCreditCard, faEnvelope, faHome, faFolderPlus, faPumpMedical, faFlask, faClockRotateLeft, faFileWaveform, faBookOpen } from "@fortawesome/free-solid-svg-icons";
import { Link } from "react-router-dom";

const menu = [
    {
        key: '1',
        icon: <FontAwesomeIcon icon={faHome} />,
        label: 'Dashboard',
        route: '/'
    },
    {
        key: '3',
        icon: <FontAwesomeIcon icon={faCalendar} />,
        label: 'Appointments',
        route: '/appointments'
    },
    {
        key: '4',
        icon: <FontAwesomeIcon icon={faFolderPlus} />,
        label: 'Health Records',
        route: '/healthrecords'
    },
    {
        key: '5',
        icon: <FontAwesomeIcon icon={faFileWaveform} />,
        label: 'Forms',
        route: '/forms'
    },
    {
        key: '6',
        icon: <FontAwesomeIcon icon={faCreditCard} />,
        label: 'Billing',
        route: '/billing'
    },
    {
        key: '7',
        icon: <FontAwesomeIcon icon={faEnvelope} />,
        label: 'Messages',
        route: '/messages'
    },
    // {
    //     key: '8',
    //     icon: <FontAwesomeIcon icon={faSliders} />,
    //     label: 'Care pathways',
    //     route: '/care'
    // },
    // {
    //     key: '9',
    //     icon: <FontAwesomeIcon icon={faPumpMedical} />,
    //     label: 'Medication',
    //     route: '/medication'
    // },
    // {
    //     key: '10',
    //     icon: <FontAwesomeIcon icon={faFlask} />,
    //     label: 'Test Results',
    //     route: '/testresults'
    // },
    // {
    //     key: '11',
    //     icon: <FontAwesomeIcon icon={faClockRotateLeft} />,
    //     label: 'History',
    //     route: '/history'
    // },

    // {
    //     key: '12',
    //     icon: <FontAwesomeIcon icon={faBookOpen} />,
    //     label: 'Health Goals',
    //     route: '/healthgoals'
    // },
]
const Mainmenu = () => {
    const key = localStorage.getItem("selectedMenuItem");
    
    const handleMenuSelect = ({ key }) => {
        localStorage.setItem('selectedMenuItem', key);
    };

    return <Menu
        theme="light"
        background="light"
        mode="inline"
        defaultSelectedKeys={[key]}
        className="s-menu"
        onSelect={handleMenuSelect}
    >
        {menu.map((menuItem) => (
            <Menu.Item key={menuItem.key} icon={menuItem.icon} className="menu-icon">
                <Link to={menuItem.route} className="text-decoration-none">
                    {menuItem.label}
                </Link>
            </Menu.Item>
        ))}
    </Menu>
}


export default Mainmenu;